import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getInvestorReportsList = createAsyncThunk(
  "investorReports/getInvestorReportsList",
  async ({ currentPage, itemsPerPage, financialYear, quarter, search }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", currentPage || 1);
      params.append("limit", itemsPerPage || 20);
      if (search) params.append("search", search);
      if (financialYear) params.append("financial_year", financialYear);
      if (quarter) params.append("quarter", quarter);

      const response = await getMethod(`/api/investor-reports?${params.toString()}`);
      const data = await response.json();
      if (!response.ok) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch reports");
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  data: [],
  pagination: {},
};

const investorReportsSlice = createSlice({
  name: "investorReports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInvestorReportsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInvestorReportsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getInvestorReportsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default investorReportsSlice.reducer;
